import Classification from "./components/Classification";
import ProfileButton from "./components/ProfileButton";
import ID from "./components/ID";
import Name from "./components/Name";
import Status from './components/Status'

export const colDefs = [
  {
    field:'ID',
    cellRenderer:ID,
    cellRendererParams: (params : any) => {
      const rowData = params.data;
      return {
        id: `${rowData.identifier}`,
      };
    },
    filter:true,
  },
  {
    field:'Nom',
    cellRenderer:Name,
    cellRendererParams: (params : any) => {
      const rowData = params.data;
      return {
        name: `${rowData.name[0]}`,
      };
    },
    filter:true,
  },
  {
    field:'Prénom',
    cellRenderer:Name,
    cellRendererParams: (params : any) => {
      const rowData = params.data;
      return {
        name: `${rowData.family}`,
      };
    },
    filter:true,
  },
  { 
    headerName:"Date de naissance",
    field: "birthDate",
  },
  {
    field:'Questionnaire',
    cellRenderer:Status,
    cellRendererParams: (params : any) => {
      const rowData = params.data;
      return {
        status: `${rowData.status}`,
        type:'questionnaire'
      };
    },
    filter:true,
  },
  {
    field:'consultation',
    cellRenderer:Status,
    cellRendererParams: (params : any) => {
      const rowData = params.data;
      return {
        status: `${rowData.is_validate}`,
        type:'validation'
      };
    },
    filter:true,
  },
  {
    field:'Classification',
    cellRenderer:Classification,
    cellRendererParams: (params : any) => {
      const rowData = params.data;
      return {
        classification: `${rowData?.classification?.classification}`,
      };
    },
    filter:true,
  },
  {
    field:'Profile',
    cellRenderer:ProfileButton,
    cellRendererParams: (params : any) => {
      const rowData = params.data;
      return {
        id: `${rowData.id}`,
      };
    },
    filter:false,
  },
];